/* eslint-disable no-use-before-define */
/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { 
	addIsSyncing, 
	removeIsSyncing, 
	addIsUnsyncing,
	removeIsUnsyncing,
	addIsDeleting,
	removeIsDeleting,
	addIsSelected,
	removeIsSelected,
	addIsQueuedForDelete,
	removeIsQueuedForDelete,
	addIsDeleted,
} from './actions';
import { postDeleteSurveys, postDeleteAllReadings, postUnsyncSurveys, postSyncSurveys } from './api';
import { selectIsBusy, selectIsSelected } from '../selectors';
import { toTimeuuids } from '../util';
import { createCompareSurveyType } from '../../../../../scanline/redux/Lines/util/survey';

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const compareSurveyType = createCompareSurveyType('surveyType');

const thunkUnsyncSurveys = (surveys, { ignoreSleep = false, onComplete = () => {}} = {}) => (dispatch, getState) => {
	const timeuuids = toTimeuuids(surveys).filter(timeuuid => !selectIsBusy(getState(), timeuuid));
	if (timeuuids.length) {
		dispatch(addIsUnsyncing(timeuuids));
		postUnsyncSurveys(timeuuids).then(async () => {
			if (!ignoreSleep) {
				await sleep(1000);
			}
			dispatch(removeIsUnsyncing(timeuuids));
			onComplete();
		});
	}
};

const thunkSyncSurveys = (surveys, { ignoreSleep = false, onComplete = () => {}} = {}) => (dispatch, getState) => {
	const timeuuids = toTimeuuids(surveys).filter(timeuuid => !selectIsBusy(getState(), timeuuid));

	const continueSync = () => {
		if (timeuuids.length) {
			dispatch(addIsSyncing(timeuuids));
			postSyncSurveys(timeuuids).then(async () => {
				if (!ignoreSleep) {
					await sleep(1000);
				}
				dispatch(removeIsSyncing(timeuuids));
				onComplete();
			});
		}
	}

	const unsyncSurveys = surveys instanceof Array ? surveys.filter(s => s.sync) : [];

	if (!unsyncSurveys.length) {
		continueSync();
	} else {
		dispatch(thunkUnsyncSurveys(unsyncSurveys, { onComplete: continueSync }))
	}
};

const thunkDeleteSurveys = (surveys, refAllSurveys, { blnAllowDeleteAll = false, onComplete = () => {}} = {}) => (dispatch, getState) => {
	const _surveys = [...surveys];
	const _refAllSurveys = [...refAllSurveys];
	_surveys.sort(compareSurveyType);
	_refAllSurveys.sort(compareSurveyType);

	const arrSurveysDeleteReadingsOnly = [];
	if (!blnAllowDeleteAll && _surveys.length === _refAllSurveys.length) {
		// assume user is trying to delete all surveys for a job line card, which we cannot allow
		arrSurveysDeleteReadingsOnly.push(_surveys.shift());
	}

	const continueDelete = () => {
		const timeuuidsDeleteSurveys = toTimeuuids(surveys).filter(timeuuid => !selectIsBusy(getState(), timeuuid));
		if (timeuuidsDeleteSurveys.length) {
			dispatch(addIsDeleting(timeuuidsDeleteSurveys));
			postDeleteSurveys(timeuuidsDeleteSurveys).then(() => {
				dispatch(removeIsDeleting(timeuuidsDeleteSurveys));
				dispatch(removeIsSelected(timeuuidsDeleteSurveys));
				dispatch(addIsDeleted(timeuuidsDeleteSurveys));
				onComplete();
			});
		}
	}

	if (arrSurveysDeleteReadingsOnly.length) {
		dispatch(thunkDeleteAllReadings(arrSurveysDeleteReadingsOnly, { onComplete: continueDelete }));
	} else {
		continueDelete();
	}
};

const thunkDeleteAllReadings = (surveys, { preventUnsync, onComplete = () => {} } = {}) => (dispatch, getState) => {
	const timeuuids = toTimeuuids(surveys).filter(timeuuid => !selectIsBusy(getState(), timeuuid));
	if (timeuuids.length) {
		dispatch(addIsDeleting(timeuuids));
		postDeleteAllReadings(timeuuids).then(() => {
			dispatch(removeIsDeleting(timeuuids));
			dispatch(removeIsSelected(timeuuids));
			if (preventUnsync) {
				onComplete();
			} else { 
				dispatch(thunkUnsyncSurveys(timeuuids, { ignoreSleep: true, onComplete }));
			}
		});
	}
};

const thunkToggleAllIsSelected = (surveys) => (dispatch, getState) => {
	const timeuuids = toTimeuuids(surveys);
	const state = getState();
	const hasSomeSelected = timeuuids.some(id => selectIsSelected(state, id));
	if (hasSomeSelected) {
		dispatch(removeIsSelected(timeuuids));
	} else {
		dispatch(addIsSelected(timeuuids));
	}
};

export { thunkUnsyncSurveys, thunkSyncSurveys, thunkDeleteSurveys, thunkDeleteAllReadings, thunkToggleAllIsSelected };
